export default [
  {
    path: '/activity-20260123-main',
    component: () => import('./Page.vue'),
    meta: { title: '冬日心愿', id: 18 },
  },
  {
    path: '/activity-20260123-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '冬日心愿-规则', id: 18 },
  },
]
